import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/ui/Header";
import { useAuthContext } from "../../context/authContext";
import useI18n from "../../hooks/useTranslations";
import { useCategoriesApi } from "../../http/useCategories";
import { NewEditAdminCategoryForm } from "./AdminCategoryForm";

export type EditAdminCategoryProps = {
  categoryCode?: string;
};

export const AdminCategory: FC<EditAdminCategoryProps> = (props) => {
  const i18n = useI18n();
  const { permissions } = useAuthContext();

  // manage category code for route and instance
  const { categoryCode } = !!props.categoryCode ? { categoryCode: props.categoryCode } : useParams<{ categoryCode: string }>();
  const categoriesApi = useCategoriesApi();

  const aborter = useRef(new AbortController());

  const categorySwr = categoriesApi.getAdminCategory(categoryCode!, aborter.current.signal);

  useEffect(() => {
    categoryCode && categorySwr.trigger();
  }, [categoryCode]);

  if (!categorySwr.data && !categorySwr.error) {
    return null;
  }

  return (
    <>
      <Header
        title={categorySwr.data?.name ?? i18n.translation.common.loading}
        error={categorySwr.error}
        path={[
          { display: i18n.translation.categories.all, url: "/admin/categories" },
          { display: categorySwr.data?.name ?? "" },
        ]}
      />

      <NewEditAdminCategoryForm
        category={!categorySwr.error ? categorySwr.data : undefined}
        disabled={categorySwr.isMutating || !!categorySwr.error || !permissions.admin.canManageCategories}
        isLoading={categorySwr.isMutating}
      />
    </>
  );
};
